// extracted by mini-css-extract-plugin
export default {"upsell":"Upsell_upsell__VdZgN"};